export const REVENOVA_ITEM_NUMBER_MAX_LENGTH = 80;

interface NormalizedRevenovaItemNumber {
  itemNumber: string;
  itemDescription: string;
}

// Conservatively count UTF-16 units without splitting a surrogate pair.
export function normalizeRevenovaItemNumber(
  itemNumber: string,
  itemDescription: string
): NormalizedRevenovaItemNumber {
  const result: NormalizedRevenovaItemNumber = { itemNumber, itemDescription };
  if (itemNumber.length <= REVENOVA_ITEM_NUMBER_MAX_LENGTH) {
    return result;
  }

  let shortened = '';
  for (const character of itemNumber) {
    if (shortened.length + character.length > REVENOVA_ITEM_NUMBER_MAX_LENGTH) {
      break;
    }
    shortened += character;
  }

  result.itemNumber = shortened;
  result.itemDescription = itemDescription.includes(itemNumber)
    ? itemDescription
    : [itemDescription, itemNumber].filter(Boolean).join('\n');
  return result;
}
